module.exports = __webpack_public_path__ + "media/2200-1_YR_2022_Ransomware.cdec92f5.mp4";